/**
 * Gift with purchase: automatically adds/removes a free 65g pineapple
 * (variant 48310812868916) once the cart's merchandise subtotal
 * (excluding the gift line itself) crosses $120 AUD (12000 cents).
 *
 * The line item that this script adds is tagged with a hidden property
 * (keys starting with "_" are hidden from the cart UI by this theme)
 * so it can always be told apart from a customer's own purchase of the
 * same product.
 *
 * The matching free-gift automatic discount ("Free Gift – 65g Pineapple
 * at $120") lives in Shopify admin > Discounts and makes this specific
 * line item's price $0 once the storewide $120 condition is met.
 */
(function () {
  var GIFT_VARIANT_ID = 48310812868916;
  var GIFT_THRESHOLD_CENTS = 12000;
  var GIFT_PROPERTY_KEY = '_atotn_gift';
  var GIFT_PROPERTY_VALUE = 'free-at-120';
  var SECTION_IDS = [
    'cart-notification-shipping',
    'cart-notification-product',
    'cart-notification-button',
    'cart-icon-bubble',
  ];

  var syncing = false;
  var resyncQueued = false;

  function otherItemsSubtotal(cart) {
    var total = 0;
    cart.items.forEach(function (item) {
      var isGiftLine = item.properties && item.properties[GIFT_PROPERTY_KEY] === GIFT_PROPERTY_VALUE;
      if (!isGiftLine) total += item.final_line_price;
    });
    return total;
  }

  function findGiftLine(cart) {
    return cart.items.find(function (item) {
      return item.properties && item.properties[GIFT_PROPERTY_KEY] === GIFT_PROPERTY_VALUE;
    });
  }

  function refreshSections(sections) {
    if (!sections) return;
    SECTION_IDS.forEach(function (id) {
      var target = document.getElementById(id);
      var html = sections[id];
      if (!target || !html) return;
      var parsed = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
      if (parsed) target.innerHTML = parsed.innerHTML;
    });
  }

  function announceCartUpdate(cartData) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gift-with-purchase', cartData: cartData });
    }
  }

  function addGift() {
    return fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: GIFT_VARIANT_ID,
            quantity: 1,
            properties: (function () {
              var props = {};
              props[GIFT_PROPERTY_KEY] = GIFT_PROPERTY_VALUE;
              return props;
            })(),
          },
        ],
        sections: SECTION_IDS,
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.sections) refreshSections(response.sections);
        return fetch('/cart.js').then(function (r) {
          return r.json();
        });
      })
      .then(function (cart) {
        announceCartUpdate(cart);
      })
      .catch(function (e) {
        console.error('[gift-with-purchase] failed to add gift', e);
      });
  }

  function removeGift(giftLine) {
    return fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: giftLine.key,
        quantity: 0,
        sections: SECTION_IDS,
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.sections) refreshSections(response.sections);
        return fetch('/cart.js').then(function (r) {
          return r.json();
        });
      })
      .then(function (cart) {
        announceCartUpdate(cart);
      })
      .catch(function (e) {
        console.error('[gift-with-purchase] failed to remove gift', e);
      });
  }

  function syncGift() {
    if (syncing) {
      resyncQueued = true;
      return;
    }
    syncing = true;

    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var qualifyingSubtotal = otherItemsSubtotal(cart);
        var giftLine = findGiftLine(cart);
        var qualifies = qualifyingSubtotal >= GIFT_THRESHOLD_CENTS;

        if (qualifies && !giftLine) return addGift();
        if (!qualifies && giftLine) return removeGift(giftLine);
        return Promise.resolve();
      })
      .catch(function (e) {
        console.error('[gift-with-purchase] sync failed', e);
      })
      .finally(function () {
        syncing = false;
        if (resyncQueued) {
          resyncQueued = false;
          syncGift();
        }
      });
  }

  document.addEventListener('DOMContentLoaded', syncGift);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'gift-with-purchase') return;
      syncGift();
    });
  }
})();
